import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-xxl-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MatchinPayHistory = _resolveComponent("MatchinPayHistory")

  return (_ctx.ccode === 0 && _ctx.pt !== 'bibo' && _ctx.pt !== 'ecc' )
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_MatchinPayHistory, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
      ]))
    : _createCommentVNode("", true)
}